export default __webpack_public_path__ + "static/winter27-6f1cb035bd659f7269effeaf7d524b80.webp";